/* Univers du Zen — interactions (vanilla, sans dépendance) */
(function () {
  'use strict';
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  /* ------------------------------------ Verrou de scroll (iOS-safe) */
  /* overflow:hidden seul ne bloque pas le scroll de fond sur iOS Safari :
     on fige le body en position:fixed et on restaure la position au déverrouillage.
     Compteur pour gérer sans casse l'ouverture simultanée de plusieurs panneaux. */
  var udzScrollY = 0, udzLockCount = 0;
  function lockScroll() {
    if (udzLockCount === 0) {
      udzScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-udzScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    udzLockCount++;
  }
  function unlockScroll() {
    udzLockCount = Math.max(0, udzLockCount - 1);
    if (udzLockCount === 0) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, udzScrollY);
    }
  }

  /* -------------------------------------------------- Méga-menu (desktop) */
  function initMega() {
    var host = $('[data-udz-menuroot]');
    if (!host) return;
    var panels = $$('[data-udz-panel]', host);
    var triggers = $$('[data-udz-menu]', host);
    var openIdx = null;

    function open(idx) {
      if (openIdx === idx) return;
      close();
      openIdx = idx;
      panels.forEach(function (p) { if (p.getAttribute('data-udz-panel') === idx) p.hidden = false; });
      triggers.forEach(function (t) { if (t.getAttribute('data-udz-menu') === idx) t.setAttribute('aria-expanded', 'true'); });
    }
    function close() {
      openIdx = null;
      panels.forEach(function (p) { p.hidden = true; });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    triggers.forEach(function (t) {
      var idx = t.getAttribute('data-udz-menu');
      t.addEventListener('mouseenter', function () { open(idx); });
      t.addEventListener('focus', function () { open(idx); });
    });
    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () { open(p.getAttribute('data-udz-panel')); });
    });
    host.addEventListener('mouseleave', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* --------------------------------------------------- Navigation mobile */
  function initMobileNav() {
    var nav = $('[data-udz-mnav]');
    if (!nav) return;
    var open = function () { nav.setAttribute('data-open', ''); lockScroll(); };
    var close = function () { nav.removeAttribute('data-open'); unlockScroll(); };
    var burger = $('[data-udz-burger]');
    if (burger) burger.addEventListener('click', open);
    $$('[data-udz-mnav-close]', nav).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* -------------------------------------------------------- Cart drawer */
  var CartDrawer = {
    el: null, overlay: null,
    init: function () {
      this.el = $('[data-udz-drawer]');
      this.overlay = $('[data-udz-cart-close].udz-overlay') || document.querySelector('.udz-overlay[data-udz-cart-close]');
      if (!this.el) return;
      var self = this;
      $$('[data-udz-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); self.open(); }); });
      document.addEventListener('click', function (e) {
        var c = e.target.closest('[data-udz-cart-close]'); if (c) { e.preventDefault(); self.close(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      this.bindActions();
    },
    open: function () { if (!this.el) return; this.el.hidden = false; if (this.overlay) this.overlay.hidden = false; lockScroll(); },
    close: function () { if (!this.el) return; this.el.hidden = true; if (this.overlay) this.overlay.hidden = true; unlockScroll(); },
    bindActions: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var qty = e.target.closest('[data-udz-qty]');
        if (qty) { e.preventDefault(); self.change(qty.getAttribute('data-line'), qty.getAttribute('data-to')); return; }
        var add = e.target.closest('[data-udz-add]');
        if (add) { e.preventDefault(); self.add(add.getAttribute('data-variant')); return; }
      });
    },
    change: function (key, to) {
      var self = this;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: parseInt(to, 10) }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self._render(cart); })
        .catch(function () {});
    },
    add: function (id, quantity) {
      if (!id) return; var self = this;
      self.open();
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: quantity ? parseInt(quantity, 10) : 1 }] }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.d && (res.d.description || res.d.message)) || 'Produit indisponible pour le moment.';
            console.warn('[UDZ] Ajout au panier refusé :', msg);
            var b = $('[data-udz-cart-body]');
            if (b) b.innerHTML = '<div class="udz-drawer__empty">Impossible d\'ajouter cet article :<br><strong>' + msg + '</strong></div>';
            return;
          }
          self.reload(false);
        })
        .catch(function () {});
    },
    reload: function (open) {
      var self = this;
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self._render(cart); if (open) self.open(); })
        .catch(function () {});
    },
    refresh: function (open) { this.reload(open); },
    _render: function (cart) {
      $$('[data-udz-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
      $$('[data-udz-cart-subtotal]').forEach(function (s) { s.textContent = money(cart.total_price); });
      var ship = $('[data-udz-ship]');
      if (ship) {
        var thr = parseInt(ship.getAttribute('data-threshold'), 10) || 0;
        if (thr > 0) {
          var rem = Math.max(0, thr - cart.total_price);
          var pct = Math.min(100, Math.round(cart.total_price * 100 / thr));
          var fill = ship.querySelector('[data-udz-ship-fill]'); if (fill) fill.style.width = pct + '%';
          var msg = ship.querySelector('[data-udz-ship-msg]'); if (msg) msg.textContent = rem > 0 ? ('Plus que ' + money(rem) + ' pour la livraison offerte') : 'Livraison offerte débloquée ✓';
        }
      }
      var body = $('[data-udz-cart-body]'); if (!body) return;
      if (!cart.item_count) { body.innerHTML = '<div class="udz-drawer__empty">Votre panier est vide.<br>Laissez-vous guider par nos rituels.</div>'; return; }
      var html = '';
      cart.items.forEach(function (it) {
        var img = it.image ? '<img src="' + it.image + '" class="udz-lineitem__thumb" alt="" loading="lazy">' : '<span class="udz-lineitem__thumb udz-ph udz-ph--sage"></span>';
        var disc = it.total_discount || 0;
        var priceHtml = disc > 0
          ? '<s style="color:var(--muted-2);font-weight:400;margin-right:6px">' + money(it.original_line_price) + '</s>' + money(it.final_line_price)
          : money(it.final_line_price);
        html += '<div class="udz-lineitem" data-udz-line-row>' + img
          + '<div style="flex:1;min-width:0"><div class="udz-lineitem__name">' + it.product_title + '</div>'
          + '<div class="udz-lineitem__unit">' + money(it.original_price) + " l'unité</div>"
          + '<div class="udz-stepper"><button type="button" data-udz-qty data-line="' + it.key + '" data-to="' + (it.quantity - 1) + '" aria-label="Diminuer">−</button><span>' + it.quantity + '</span><button type="button" data-udz-qty data-line="' + it.key + '" data-to="' + (it.quantity + 1) + '" aria-label="Augmenter">+</button></div></div>'
          + '<div style="text-align:right"><div class="udz-lineitem__name">' + priceHtml + '</div><button type="button" class="udz-remove" data-udz-qty data-line="' + it.key + '" data-to="0" style="margin-top:8px">Retirer</button></div>'
          + '</div>';
      });
      body.innerHTML = html;
    }
  };

  /* ------------------------------------------- Utilitaires réutilisables */
  function initCarousels() {
    $$('[data-udz-carousel]').forEach(function (c) {
      var track = $('[data-udz-track]', c);
      if (!track) return;
      var step = Math.max(track.clientWidth * 0.8, 280);
      var prev = $('[data-udz-prev]', c), next = $('[data-udz-next]', c);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step, behavior: 'smooth' }); });
    });
  }

  function initReveal() {
    var els = $$('[data-udz-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.style.opacity = '1'; en.target.style.transform = 'none'; io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el, i) {
      el.style.opacity = '0'; el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .7s ease, transform .7s ease';
      el.style.transitionDelay = ((i % 4) * 0.09) + 's';
      io.observe(el);
    });
  }

  function initCounters() {
    var els = $$('[data-udz-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, target = parseInt(el.getAttribute('data-udz-count'), 10), suf = el.getAttribute('data-udz-suffix') || '';
        io.unobserve(el);
        var t0 = null;
        function tick(now) {
          if (!t0) t0 = now;
          var p = Math.min(1, (now - t0) / 1400), e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * e) + suf;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAccordions() {
    $$('[data-udz-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-udz-acc]');
        var panel = $('[data-udz-acc-panel]', item);
        var open = item.hasAttribute('data-open');
        if (open) { item.removeAttribute('data-open'); if (panel) panel.hidden = true; }
        else { item.setAttribute('data-open', ''); if (panel) panel.hidden = false; }
      });
    });
  }

  function boot() {
    initMega(); initMobileNav(); CartDrawer.init();
    initCarousels(); initReveal(); initCounters(); initAccordions();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.UDZ = { cart: CartDrawer };
})();
